// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 787 ? "plotly" : chunkId) + "." + {"87":"66569135","422":"03e316e0","787":"cf4cb21f"}[chunkId] + ".chunk.js";
};